import Box from "@mui/material/Box";
import {Fade} from "@mui/material";
import Typography from "@mui/material/Typography";
import React, {useState} from "react";
import {useLocation} from "react-router-dom";
import AppMenuBarInfoDialogue from "./Info/AppMenuBarInfoDialogue";


export default function AppMenuBarLogo() {

    const [appMenuBarInfoOpen, setAppMenuBarInfoOpen] = useState(false);
    const { pathname } = useLocation();        // current URL path
    const isSplash = pathname === "/";         // change if your splash is a different route


    const handleAppMenuBarInfo = () => {
        setAppMenuBarInfoOpen(true);
    };

    const handleCloseAppMenuBarInfo = () => {
        setAppMenuBarInfoOpen(false);
    };

    return(
        <Box
            sx={{
                alignItems: 'center'
                    // ,        flexGrow: 8
        }}
        >
            {!isSplash && (
                <Fade in timeout={2000}>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        style={{cursor:'pointer'}}   onClick={() => handleAppMenuBarInfo()}
                        sx={{
                            display: { xs: "block", sm: "block" }, // or remove if not needed
                            textAlign: "center",                    // change to 'center' or 'left' as needed
                            // pl: 74,                                // padding-left: 16px (theme spacing)
                            pt: 0                                 // optional: padding-top to bump it from the top
                        }}
                    >Contramatic
                    </Typography>
                </Fade>)}
            <AppMenuBarInfoDialogue
                open={appMenuBarInfoOpen}
                onClose={handleCloseAppMenuBarInfo}
            />
        </Box>
        
    )

}